// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.candidate-static-title {
  font-weight: 300;
  font-size: 16px;
}

.sticky-static-candidate-header {
  background-color: #fff;
  padding: 1rem 1rem 0.25rem 1rem;
  margin-top: -1.5rem;
  margin-right: calc(-1.5rem * 0.5);
  margin-left: calc(-1.5rem * 0.5);
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.031);
}

.static-grid {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.static-grid-item {
  position: relative;
  flex: 1 1 20%;
  width: 90%;
  max-width: 18%;
  box-sizing: border-box;
  padding: 0.4rem;
  padding-left: 15px;
  margin-bottom: 0.4rem;
  margin-right: 0.4rem;
}

.static-grid-item-selected {
  border: 1.2px solid #0a56ae;
  border-radius: 8px;
}

.static-grid-item-selectable:hover {
  cursor: pointer;
  background: #f5f5f5;
  border-radius: 8px;
}

.static-grid-item:active {
  background-color: white;
}

.static-grid-item-selected-icon {
  position: absolute;
  right: 10px;
  bottom: 6px;
  color: #0a56ae;
}

.static-header-count {
  font-size: 12.5px;
  font-weight: 500;
  color: #0a56ae;
}

.static-header-title {
  font-weight: 400;
  color: gray;
  font-size: 12.5px;
}

.static-table-header-item {
  font-size: 11px;
  font-weight: 500;
}

.candidate-static-filter-offcanvas {
  width: 25vw;
  border: 1px solid transparent;
}

.csf-title {
  font-weight: 500;
  font-size: 17px;
}

.csf-apply,
.csf-clear:hover {
  border: 1px solid #0a56ae;
  background-color: #0a56ae;
  border-radius: 0;
  color: #fff;
  font-weight: 500;
}

.csf-clear,
.csf-apply:hover {
  border: 1px solid #0a56ae;
  background-color: #fff;
  border-radius: 0;
  color: #0a56ae;
  font-weight: 500;
}

.filter-bubble {
  background-color: #0a56ae;
  color: #fff;
  height: 20px;
}

.filter-bubble-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.rounded-filter-length {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: #fff;
  color: #0a56ae;
  font-weight: 500;
  font-size: 6px;
  width: 10px;
  height: 10px;
  padding: 6px;
}

@media (min-width: 1024px) {
  .wrapper-height {
    height: calc(80vh - 195px);
  }

  .rounded-filter-length {
    font-size: 8px;
  }
}
@media (min-width: 1366px) {
  .static-header-count {
    font-size: 15px;
  }

  .static-header-title {
    font-size: 14px;
  }

  .static-table-header-item {
    font-size: 14px;
  }

  .candidate-static-title {
    font-size: 18px;
  }

  .wrapper-height {
    height: calc(100vh - 320px);
  }

  .rounded-filter-length {
    font-size: 8.5px;
  }
}
@media (min-width: 1920px) {
  .filter-bubble {
    font-size: 11px;
  }

  .rounded-filter-length {
    font-size: 8px;
  }

  .wrapper-height {
    height: calc(100vh - 350px);
  }
}`, "",{"version":3,"sources":["webpack://./../candidate/src/pages/CandidateStaticReport/CandidateStaticReport.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iCAAA;EACA,gCAAA;EACA,mBAAA;EACA,4CAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AACA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,6BAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;AAEF;;AACA;;EAEE,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;;EAEE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,0BAAA;EAEF;;EACA;IACE,cAAA;EAEF;AACF;AACA;EACE;IACE,eAAA;EACF;;EAEA;IACE,eAAA;EACF;;EAEA;IACE,eAAA;EACF;;EAEA;IACE,eAAA;EACF;;EAEA;IACE,2BAAA;EACF;;EAEA;IACE,gBAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;EAAF;;EAEA;IACE,cAAA;EACF;;EAEA;IACE,2BAAA;EACF;AACF","sourcesContent":[".candidate-static-title {\n  font-weight: 300;\n  font-size: 16px;\n}\n\n.sticky-static-candidate-header {\n  background-color: #fff;\n  padding: 1rem 1rem 0.25rem 1rem;\n  margin-top: -1.5rem;\n  margin-right: calc(-1.5rem * 0.5);\n  margin-left: calc(-1.5rem * 0.5);\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.031);\n}\n\n.static-grid {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.static-grid-item {\n  position: relative;\n  flex: 1 1 20%;\n  width: 90%;\n  max-width: 18%;\n  box-sizing: border-box;\n  padding: 0.4rem;\n  padding-left: 15px;\n  margin-bottom: .4rem;\n  margin-right: .4rem;\n}\n\n.static-grid-item-selected {\n  border: 1.2px solid #0a56ae;\n  border-radius: 8px;\n}\n\n.static-grid-item-selectable:hover {\n  cursor: pointer;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.static-grid-item:active {\n  background-color: white;\n}\n\n.static-grid-item-selected-icon {\n  position: absolute;\n  right: 10px;\n  bottom: 6px;\n  color: #0a56ae;\n}\n\n.static-header-count {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #0a56ae;\n}\n.static-header-title {\n  font-weight: 400;\n  color: gray;\n  font-size: 12.5px;\n}\n\n.static-table-header-item {\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.candidate-static-filter-offcanvas {\n  width: 25vw;\n  border: 1px solid transparent;\n}\n\n.csf-title {\n  font-weight: 500;\n  font-size: 17px;\n}\n\n.csf-apply,\n.csf-clear:hover {\n  border: 1px solid #0a56ae;\n  background-color: #0a56ae;\n  border-radius: 0;\n  color: #fff;\n  font-weight: 500;\n}\n\n.csf-clear,\n.csf-apply:hover {\n  border: 1px solid #0a56ae;\n  background-color: #fff;\n  border-radius: 0;\n  color: #0a56ae;\n  font-weight: 500;\n}\n\n.filter-bubble {\n  background-color: #0a56ae;\n  color: #fff;\n  height: 20px;\n}\n\n.filter-bubble-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rounded-filter-length {\n  display: flex;\n  justify-content: center;\n  align-items: center;  \n  border-radius: 100%;\n  background-color: #fff;\n  color: #0a56ae;\n  font-weight: 500;\n  font-size: 6px;\n  width: 10px;\n  height: 10px;\n  padding: 6px;\n}\n\n@media (min-width: 1024px) {\n  .wrapper-height {\n    height: calc(80vh - 195px);\n  }\n\n  .rounded-filter-length {\n    font-size: 8px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .static-header-count {\n    font-size: 15px;\n  }\n\n  .static-header-title {\n    font-size: 14px;\n  }\n\n  .static-table-header-item {\n    font-size: 14px;\n  }\n\n  .candidate-static-title {\n    font-size: 18px;\n  }\n\n  .wrapper-height {\n    height: calc(100vh - 320px);\n  }\n\n  .rounded-filter-length {\n    font-size: 8.5px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .filter-bubble {\n    font-size: 11px;\n  }\n  .rounded-filter-length {\n    font-size: 8px;\n  }\n\n  .wrapper-height {\n    height: calc(100vh - 350px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
